import { api } from './api';

export const eventService = {
    getEvents: async () => {
        return api.get('/events?IsDeleted=false');
    },

    getEventById: async (id) => {
        return api.get(`/events/${id}`);
    },

    createEvent: async (formData) => {
        return api.post('/events', formData);
    },

    updateEvent: async (id, formData) => {
        return api.post(`/events/${id}`, formData);
    },

    deleteEvent: async (id) => {
        return api.delete(`/events/${id}`);
    },

    joinEvent: async (payload) => {
        return api.post('/events-join', payload);
    },

    getEventJoins: async () => {
        return api.get('/events-join');
    },

    getEventJoinById: async (id) => {
        return api.get(`/events-join/${id}`);
    },

    updateEventJoin: async (id, payload) => {
        return api.post(`/events-join/${id}`, payload);
    },

    deleteEventJoin: async (id) => {
        return api.delete(`/events-join/${id}`);
    },
};
